import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const shareButtonEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "share-button-entrypoint" */ './ui/async.tsx'),
	),
	getPreloadProps: () => ({}),
});
